import {useMutation, useQueryClient} from '@tanstack/react-query';

import {createVideoEventSchedule, CreateVideoEventScheduleParams} from '../api';
import {QUERY__VIDEO_SCHEDULES} from '../queryKeys';

export const useCreateVideoEventSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateVideoEventScheduleParams) =>
      createVideoEventSchedule(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__VIDEO_SCHEDULES],
      });
    },
  });
};
